<template lang="pug">
    .address
        el-form-item(:label="$t('Street')" :prop="validationPath + '.street'")
            el-input(v-model="street" maxlength="255" show-word-limit)
        el-row.no-padding(:gutter="20")
            el-col(:lg="8" :md="8")
                el-form-item(:label="$t('Zipcode')" :prop="validationPath + '.zipcode'")
                    el-input(v-model="zipcode" maxlength="255" show-word-limit)
            el-col(:lg="16" :md="16")
                el-form-item(:label="$t('City')" :prop="validationPath + '.city'")
                    el-input(v-model="city" maxlength="255" show-word-limit)
        el-form-item(:label="$t('Country')" :prop="validationPath + '.country'")
            el-select.is-full-width(placeholder="" filterable v-model="country" autocomplete="no-fill")
                el-option(v-for="(label, value) in countries" :key="value" :label="label" :value="value")

        el-form-item.default-switches(:prop="validationPath + '.defaultSwitches'" v-if="showDefaultSwitches")
            el-switch(:active-text="$t('Default Billing')" v-model="defaultBilling")
            el-switch(:active-text="$t('Default Shipping')" v-model="defaultShipping")
</template>

<i18n>
{
  "de": {
    "Street": "Straße",
    "Zipcode": "PLZ",
    "City": "Ort",
    "Country": "Land",
    "Default Billing": "Standard Rechnungsadresse",
    "Default Shipping": "Standard Versandadresse"
  }
}
</i18n>

<script>

import countries from 'i18n-iso-countries'
import en from 'i18n-iso-countries/langs/en.json'
import de from 'i18n-iso-countries/langs/de.json'

countries.registerLocale(en)
countries.registerLocale(de)

import store from '@/store'

export default {
    name: 'Address',
    data() {
        return {}
    },
    props: {
        data: {
            type: Object,
            required: true,
        },
        index: {
            type: Number,
            required: true,
        },
        showDefaultSwitches: {
            type: Boolean,
            default: false,
        }
    },
    components: {},
    computed: {
        validationPath() {
            return `addresses.${this.index}`
        },
        countries() {
            return countries.getNames('de')
        },
        street: {
            get() {
                return this.data.street
            },
            set(value) {
                store.commit('account/form/street', { i: this.index, value })
            }
        },
        zipcode: {
            get() {
                return this.data.zipcode
            },
            set(value) {
                store.commit('account/form/zipcode', { i: this.index, value })
            }
        },
        city: {
            get() {
                return this.data.city
            },
            set(value) {
                store.commit('account/form/city', { i: this.index, value })
            }
        },
        country: {
            get() {
                return this.data.country
            },
            set(value) {
                store.commit('account/form/country', { i: this.index, value })
            }
        },
        defaultBilling: {
            get() {
                return this.data.default_billing
            },
            set(value) {
                store.commit('account/form/defaultBilling', { i: this.index, value })
            }
        },
        defaultShipping: {
            get() {
                return this.data.default_shipping
            },
            set(value) {
                store.commit('account/form/defaultShipping', { i: this.index, value })
            }
        },
    },
    methods: {},
}

</script>


<style lang="sass">
.el-switch
    margin-right: 40px
</style>
